import Vue from "vue";
import Router from "vue-router";
import store from "../store";
// import { VueReCaptcha } from "vue-recaptcha-v3";

import AppPage from "@/pages/application-page";

// static pages
import SignPage from "@/pages/static/sign-page";
import SignInPage from "@/pages/static/signin-page";
import ForgotPassword from "@/pages/static/forgot-password-page.vue";
import ResetPassword from "@/pages/static/reset-password-page.vue";
import Redirect from "@/pages/static/redirect-page";
import FinishVerifyPage from "@/pages/static/finish-verify-page";

// Insight pages
import InsightPage from "@/pages/insight-pages/insight-page";
import InsightCompanyPage from "@/pages/insight-pages/insight-company-page";
import InsightNewsPage from "@/pages/insight-pages/insight-news-page";
import InsightOpinionPage from "@/pages/insight-pages/insight-opinion-page";

// Insight Company Pages
const CompanyTearsheet = () => import("@/components/insight-page-components/company-tearsheet");
const CompanyFinancials = () => import("@/components/insight-page-components/company-financials");
const CompanyInsider = () => import("@/components/insight-page-components/company-insider");
const CompanyOwnership = () => import("@/components/insight-page-components/company-ownership");
const CompanySEC = () => import("@/components/insight-page-components/company-sec");

// maintenance
// import MaintenancePage from "@/pages/static/maintenance-page.vue";
// import SolutionPage from "@/pages/static/solution-page";

// import board into admin-page
import DashBoard from "@/components/board/dash-board";
import UserInfo from "@/components/card/user-info-card.vue";
import ApiKeyInfo from "@/components/card/apikey-info-card.vue";
import PaymentInfo from "@/components/card/payment-info-card.vue";
import SubInfo from "@/components/card/sub-info-card.vue";
import DownloadHistoryInfo from "@/components/card/download-info-card.vue";

// API Documentation
const ApiPage = () => import("@/pages/api-docs-pages/api-page");
const ApiDocsPage = () => import("@/pages/api-docs-pages/api-docs-page");
const ApiDocsContentPage = () => import("@/pages/api-docs-pages/api-docs-content-page");
const ApiDescriptionPage = () => import("@/pages/api-docs-pages/api-description-page");

const TerminalPage = () => import("@/pages/terminal-page");
const AdPage = () => import("@/pages/static/advertising-page");
const PricingPage = () => import("@/pages/static/pricing-page");
const ErrorPage = () => import("@/pages/static/error-page");

// Enterprice
const EnterprisePage = () => import("@/pages/enterprise-page");

Vue.use(Router);
// Vue.use(VueReCaptcha, {
//   siteKey: "6LcZ85oUAAAAAOwwpoLFXPlYw9xIPv8PwqODv3O9",
//   loaderOptions: {
//     autoHideBadge: true,
//   },
// });

const router = new Router({
  mode: "history",
  routes: [
    // API Page route
    {
      path: "/",
      name: "home-page", // Never Change This Name!
      // component: InsightPage,
      // redirect: "/insight/news",
      redirect: "/solution"
    },
    // {
    //   path: "/insight",
    //   name: "insight-page",
    //   component: InsightPage,
    //   redirect: { name: "insight-news-page" },
    //   children: [
    //     {
    //       path: "news",
    //       name: "insight-news-page",
    //       component: InsightNewsPage,
    //     },
    //     {
    //       path: "company",
    //       name: "insight-company-page",
    //       component: InsightCompanyPage,
    //       redirect: { name: "company-tearsheet-page", params: { ticker: 'aapl' } },
    //       props: true,
    //       children: [
    //         {
    //           path: "tearsheet",
    //           name: "company-tearsheet-page-default",
    //           component: CompanyTearsheet,
    //           redirect: { name: "company-tearsheet-page", params: { ticker: 'aapl' } },
    //           children: [
    //             {
    //               path: ":ticker",
    //               name: "company-tearsheet-page",
    //               component: CompanyTearsheet,
    //             },
    //           ]
    //         },
    //         {
    //           path: "financials",
    //           name: "company-financials-page-default",
    //           component: CompanyFinancials,
    //           redirect: { name: "company-financials-page", params: { ticker: 'aapl' } },
    //           children: [
    //             {
    //               path: ":ticker",
    //               name: "company-financials-page",
    //               component: CompanyFinancials,
    //             },
    //           ]
    //         },
    //         {
    //           path: "insider",
    //           name: "company-insider-page-default",
    //           component: CompanyInsider,
    //           redirect: { name: "company-insider-page", params: { ticker: 'aapl' } },
    //           children: [
    //             {
    //               path: ":ticker",
    //               name: "company-insider-page",
    //               component: CompanyInsider,
    //             },
    //           ]
    //         },
    //         {
    //           path: "ownership",
    //           name: "company-ownership-page-default",
    //           component: CompanyOwnership,
    //           redirect: { name: "company-ownership-page", params: { ticker: 'aapl' } },
    //           children: [
    //             {
    //               path: ":ticker",
    //               name: "company-ownership-page",
    //               component: CompanyOwnership,
    //             },
    //           ]
    //         },
    //         {
    //           path: "secfiling",
    //           name: "company-secfiling-page-default",
    //           component: CompanySEC,
    //           redirect: { name: "company-secfiling-page", params: { ticker: 'aapl' } },
    //           children: [
    //             {
    //               path: ":ticker",
    //               name: "company-secfiling-page",
    //               component: CompanySEC,
    //             },
    //           ]
    //         },
    //       ]
    //       // children: [
    //       //   {
    //       //     path: "tearsheet/:ticker",
    //       //     name: "company-tearsheet-page",
    //       //     component: CompanyTearsheet,
    //       //   },
    //       //   {
    //       //     path: "financials/:ticker",
    //       //     name: "company-financials-page",
    //       //     component: CompanyFinancials,
    //       //   },
    //       //   {
    //       //     path: "insider/:ticker",
    //       //     name: "company-insider-page",
    //       //     component: CompanyInsider,
    //       //   },
    //       //   {
    //       //     path: "ownership/:ticker",
    //       //     name: "company-ownership-page",
    //       //     component: CompanyOwnership,
    //       //   },
    //       //   {
    //       //     path: "secfiling/:ticker",
    //       //     name: "company-sec-filing-page",
    //       //     component: CompanySEC,
    //       //   }

    //       // ]
    //     },
    //     {
    //       path: "opinion",
    //       name: "insight-opinion-page",
    //       component: InsightOpinionPage
    //     }
    //   ]
    // },

    {
      path: "/product",
      redirect: "/solution"
    },

    {
      path: "/solution",
      name: "advertising-page",
      component: AdPage
    },

    {
      path: "/api",
      name: "api-page",
      component: ApiPage,
      // redirect: { name: "api-docs-page" },
      redirect: "/api/docs/V2.0/introduction",
      children: [
        {
          path: "docs",
          name: "api-docs-page",
          component: ApiDocsPage,
          // redirect: "/api/docs/V2.0/introduction",
          redirect: { name: "api-docs-content-page" },
          children: [
            {
              path: ":version",
              name: "api-docs-content-page",
              component: ApiDocsContentPage,
              // redirect: "/api/docs/V2.0/introduction",
              redirect: { name: "api-docs-description-page" },
              children: [
                {
                  path: ":api",
                  name: "api-docs-description-page",
                  component: ApiDescriptionPage
                }
              ]
            }
          ]
        }
      ]
    },

    {
      path: "/pricing",
      name: "pricing-page",
      component: PricingPage
    },

    // Finish Verify Page
    {
      path: "/finish-verify-page/:vcode",
      name: "finish-verify-page",
      component: FinishVerifyPage
    },
    {
      path: "/signin",
      name: "signin-page",
      component: SignInPage
    },
    {
      path: "/signup",
      name: "signup-page",
      component: SignPage
    },
    {
      path: "/upgrade",
      name: "upgrade-page",
      component: SignPage
    },
    {
      path: "/app",
      name: "application-page",
      component: AppPage,
      meta: {
        requiresAuth: true
      },
      redirect: { name: "dash-board" },
      children: [
        {
          path: "admin",
          name: "dash-board",
          component: DashBoard,
          redirect: { name: "user-info" },
          children: [
            {
              path: "info",
              name: "user-info",
              component: UserInfo
            },
            {
              path: "apikey",
              name: "api-keys-info",
              component: ApiKeyInfo
            },
            {
              path: "payment",
              name: "payment-info",
              component: PaymentInfo
            },
            {
              path: "subcription",
              name: "sub-info",
              component: SubInfo
            },
            {
              path: "history",
              name: "download-info",
              component: DownloadHistoryInfo
            }
          ]
        }
      ]
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: ForgotPassword
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: ResetPassword
    },
    {
      path: "/redirect",
      name: "redirect",
      component: Redirect
    },
    {
      path: "/enterprise",
      name: "enterprise",
      component: EnterprisePage
    },
    {
      path: "terminal",
      name: "terminal-page",
      component: TerminalPage
    },
    {
      path: "*",
      redirect: { name: "error-page" }
    },
    {
      path: "/404",
      name: "error-page",
      component: ErrorPage
    }
  ]
});

router.beforeEach((to, from, next) => {
  const loadSessionFromLocalStorage = localStorage.getItem("token");
  const storeLoggedIn = store.getters.isLogin;
  const isLogged = storeLoggedIn || loadSessionFromLocalStorage;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isLogged) {
      next();
    } else {
      next({ path: "/signin-page", params: { nextUrl: to.fullPath } });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js